// Tap-to-done timing (plan §14: p95 under 15 s). Measured on the device from the "Collect a
// child" tap to the moment the event is in the signed outbox, kept as a short rolling list.

export const METRICS_KEEP = 200;

/** Nearest-rank percentile of `values` (0 < p <= 100); null when empty. */
export function percentile(values: readonly number[], p: number): number | null {
  if (!values.length) return null;
  const sorted = [...values].sort((a, b) => a - b);
  const rank = Math.min(sorted.length, Math.max(1, Math.ceil((p / 100) * sorted.length)));
  return sorted[rank - 1]!;
}

/** Appends one sample and drops the oldest beyond `keep`. Whole milliseconds. */
export function addSample(list: readonly number[], ms: number, keep = METRICS_KEEP): number[] {
  const next = [...list, Math.max(0, Math.round(ms))];
  return next.length > keep ? next.slice(next.length - keep) : next;
}

export function summary(list: readonly number[]) {
  return { count: list.length, p50: percentile(list, 50), p95: percentile(list, 95) };
}

/** "8.4 s" for display. */
export const seconds = (ms: number | null) => (ms == null ? "No data yet" : `${(ms / 1000).toFixed(1)} s`);
